// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#demandjumpKeywords .input-style {
  margin-bottom: 10px;
  height: 44px;
  width: 272px;
  padding: 2px 8px;
  font-size: 20px;
  font-family: "Source Sans Pro", sans-serif;
  color: #373F50;
  margin-right: 16px;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  border: 1px solid #D3D7E0;
}
#demandjumpKeywords .input-style:focus {
  outline: 1px solid #008cce;
}
#demandjumpKeywords .keywords-upload-button {
  background-color: white;
  border: 1px solid #008cce;
  color: #008cce;
  border-radius: 3px;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  padding: 8px 10px;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  font-family: "Source Sans Pro", sans-serif;
  box-shadow: 0px 4px 8px 0px rgba(55, 63, 80, 0.2509803922);
  margin-top: 15px;
}
#demandjumpKeywords .keywords-upload-button:hover {
  background-color: #008cce;
  color: white;
}
#demandjumpKeywords .keywords-upload-button:hover .upload-icon {
  background-color: #008cce;
  color: white;
}
#demandjumpKeywords .keywords-cancel-button {
  background-color: white;
  border: 1px solid #008cce;
  color: #008cce;
  border-radius: 3px;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  padding: 8px 10px;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  font-family: "Source Sans Pro", sans-serif;
  box-shadow: 0px 4px 8px 0px rgba(55, 63, 80, 0.2509803922);
}
#demandjumpKeywords .keywords-cancel-button:hover {
  background-color: #008cce;
  color: white;
}
#demandjumpKeywords .divider {
  margin-top: 1rem;
  margin-bottom: 1rem;
  height: 1px;
  overflow: hidden;
  background: #e9ecef;
}
#demandjumpKeywords .keywords-save-button {
  background-color: #008cce;
  border: 1px solid #008cce;
  color: white;
  border-radius: 3px;
  font-size: 16px;
  font-weight: 500;
  outline: none;
  padding: 8px 10px;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  font-family: "Source Sans Pro", sans-serif;
  box-shadow: 0px 4px 8px 0px rgba(55, 63, 80, 0.2509803922);
}
#demandjumpKeywords .keywords-save-button:hover {
  background-color: white;
  color: #008cce;
}

#formWrapper .section-title {
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: 0.4px;
  color: rgba(0, 0, 0, 0.6);
}
#formWrapper .dj-skeleton-shape {
  height: 1000px;
  color: grey;
  outline: none;
  border-radius: 4px;
  background-color: #f0f0f0;
  border: none;
  width: 100%;
  height: 100%;
  padding: 8px;
  font-size: 16px;
  line-height: 1.5;
  transition: all 0.2s ease-out;
  resize: none;
}`, "",{"version":3,"sources":["webpack://./src/components/settings/Keywords/keywords.scss"],"names":[],"mappings":"AAGE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;AAFJ;AAIE;EACE,0BAAA;AAFJ;AAIE;EACE,uBAAA;EACA,yBAAA;EACA,cAvBY;EAwBZ,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,0CAAA;EACA,0DAAA;EACA,gBAAA;AAFJ;AAIE;EACE,yBAtCY;EAuCZ,YAAA;AAFJ;AAIE;EACE,yBA1CY;EA2CZ,YAAA;AAFJ;AAIE;EACE,uBAAA;EACA,yBAAA;EACA,cAhDY;EAiDZ,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,0CAAA;EACA,0DAAA;AAFJ;AAIE;EACE,yBA9DY;EA+DZ,YAAA;AAFJ;AAIE;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAFJ;AAIE;EACE,yBAzEY;EA0EZ,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,0CAAA;EACA,0DAAA;AAFJ;AAIE;EACE,uBAAA;EACA,cA1FY;AAwFhB;;AAOE;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;AAJJ;AAME;EACM,cAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;AAJR","sourcesContent":["$dj-blue-color: #008cce;\n\n#demandjumpKeywords {\n  .input-style {\n    margin-bottom: 10px;\n    height: 44px;\n    width: 272px;\n    padding: 2px 8px;\n    font-size: 20px;\n    font-family: 'Source Sans Pro', sans-serif;\n    color: #373F50;\n    margin-right: 16px;\n    border-radius: 4px;\n    border-style: solid;\n    border-width: 1px;\n    border: 1px solid #D3D7E0;\n  }\n  .input-style:focus {\n    outline: 1px solid $dj-blue-color;\n  }\n  .keywords-upload-button{\n    background-color: white;\n    border: 1px solid $dj-blue-color;\n    color: $dj-blue-color;\n    border-radius: 3px;\n    font-size: 16px;\n    font-weight: 600;\n    outline: none;\n    padding: 8px 10px;\n    display: inline-block;\n    text-align: center;\n    vertical-align: middle;\n    user-select: none;\n    font-family: 'Source Sans Pro', sans-serif;;\n    box-shadow: 0px 4px 8px 0px #373F5040;\n    margin-top: 15px;\n  }\n  .keywords-upload-button:hover{\n    background-color: $dj-blue-color;\n    color: white;\n  }\n  .keywords-upload-button:hover .upload-icon{\n    background-color: $dj-blue-color;\n    color: white;\n  }\n  .keywords-cancel-button{\n    background-color: white;\n    border: 1px solid $dj-blue-color;\n    color: $dj-blue-color;\n    border-radius: 3px;\n    font-size: 16px;\n    font-weight: 600;\n    outline: none;\n    padding: 8px 10px;\n    display: inline-block;\n    text-align: center;\n    vertical-align: middle;\n    user-select: none;\n    font-family: 'Source Sans Pro', sans-serif;;\n    box-shadow: 0px 4px 8px 0px #373F5040;\n  }\n  .keywords-cancel-button:hover{\n    background-color: $dj-blue-color;\n    color: white;\n  }\n  .divider {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    height: 1px;\n    overflow: hidden;\n    background: #e9ecef;\n  }\n  .keywords-save-button{\n    background-color: $dj-blue-color;\n    border: 1px solid $dj-blue-color;\n    color: white;\n    border-radius: 3px;\n    font-size: 16px;\n    font-weight: 500;\n    outline: none;\n    padding: 8px 10px;\n    display: inline-block;\n    text-align: center;\n    vertical-align: middle;\n    user-select: none;\n    font-family: 'Source Sans Pro', sans-serif;;\n    box-shadow: 0px 4px 8px 0px #373F5040;\n  }\n  .keywords-save-button:hover{\n    background-color: white;\n    color: $dj-blue-color;\n  }\n}\n\n#formWrapper {\n  .section-title {\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: 1.33;\n    letter-spacing: 0.4px;\n    color: rgba(0, 0, 0, 0.6);\n  }\n  .dj-skeleton-shape {\n        height: 1000px;\n        color: grey;\n        outline: none;\n        border-radius: 4px;\n        background-color: #f0f0f0;\n        border: none;\n        width: 100%;\n        height: 100%;\n        padding: 8px;\n        font-size: 16px;\n        line-height: 1.5;\n        transition: all 0.2s ease-out;\n        resize: none;\n      }\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
